import React from 'react';
import Header from '../../components/Header';
import StoreManagerRequestsTable from '../../tables/StoreManagement/StoreManagerRequestsTable';


const StoreManagerStockRequestPage = () => {
    return ( 
        <>
      <div className="min-h-screen bg-[#F6F7F6]">
        <Header text="Stock Request" />
            <div className="mt-6">
              <StoreManagerRequestsTable />
            </div>
        </div>
      </>
     );
}
 
export default StoreManagerStockRequestPage;